import * as React from 'react'
import { css } from '@emotion/react'
import { TableCell, TableRow } from '../../atoms/Table'
import { CompanyData } from '../../../types/api'
import { isPrivate, isIPO } from '@/lib/company'
import { FormattedDate } from '../../atoms/FormattedDate'
import { FormattedNumber } from '../../atoms/FormattedNumber'
import { CompanySummaryCell } from './internal/CompanySummaryCell'
import { PayWallText } from '@/components/pages/companies/components/pay-wall-text'

export const CompaniesTableBody: React.FC<{
  items: CompanyData[]
  withTotalFunding: boolean
  isSeriesVisible: boolean
  isPostMoneyVisible: boolean
}> = ({
  items,
  withTotalFunding: totalFunding,
  isSeriesVisible,
  isPostMoneyVisible,
}) => {
  return (
    <tbody>
      {items.map((company, i) => {
        return (
          <TableRow highlightOnHover key={i} className="row">
            <CompanySummaryCell
              company={company}
              css={css`
                width: ${totalFunding ? '50%' : '60%'};
              `}
            />
            <TableCell nowrap centerized>
              <FormattedDate>{company.establishedAt}</FormattedDate>
            </TableCell>
            <TableCell nowrap centerized className="last-funding-date">
              <FormattedDate>{company.latestFundraise?.date}</FormattedDate>
            </TableCell>
            <TableCell centerized>
              {isSeriesVisible ? (
                isPrivate(company) && company.latestInitialSeries
              ) : (
                <PayWallText dataTestId="series-pay-wall-text" />
              )}
            </TableCell>
            {totalFunding && (
              <TableCell
                vertical="middle"
                align="right"
                className="total-fundraise"
              >
                {company.totalFundraise && company.totalFundraise !== 0 ? (
                  <FormattedNumber
                    sub={company.hasEstimatedRound ? '（推測）' : ''}
                  >
                    {company.totalFundraise && company.totalFundraise}
                  </FormattedNumber>
                ) : (
                  ''
                )}
              </TableCell>
            )}
            <TableCell
              vertical="middle"
              align={isPostMoneyVisible ? 'right' : 'center'}
            >
              {isPostMoneyVisible ? (
                <FormattedNumber
                  sub={
                    isIPO(company)
                      ? 'IPO前最終調達時'
                      : company.hasEstimatedRound
                        ? '（推測）'
                        : ''
                  }
                >
                  {company.valuation}
                </FormattedNumber>
              ) : (
                <PayWallText dataTestId="money-valuation-pay-wall-text" />
              )}
            </TableCell>
          </TableRow>
        )
      })}
    </tbody>
  )
}
